import { EventEmitter, Component, ChangeDetectionStrategy, Renderer2, ElementRef, ChangeDetectorRef, ContentChildren, ViewChild, Input, Output, NgModule, CUSTOM_ELEMENTS_SCHEMA, Directive, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Type, TooltipModule, PopupModule } from '@wke/ucc-angular-alt-common';
import { IconModule } from '@wke/ucc-icons';
import { SplitButtonModule as SplitButtonModule$1, ButtonsModule as ButtonsModule$1 } from '@progress/kendo-angular-buttons';
import { debounceTime, takeWhile } from 'rxjs/operators';

/**
 * Este componente utiliza la interfaz [Toolbar Item]{@link ToolbarItem} y tiene como objetivo declarar un toolbar item que funciona
 * como un botón, el cual se puede habilitar o deshabilitar, hacer visible o no visible, tener o no una label que lo describa,
 * y hacer que haga diferentes funciones personalizables por el usuario
 *
 * @example
 *      <ngwk-toolbar-item [label]='label' [labelPosition]='position' [icon]='icon' (actionClick)='function()' [checked]='checked' [visible]='visible' [disabled]='disabled'></ngwk-toolbar-item>
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@wke/ucc-icons';
import * as ɵngcc3 from '@wke/ucc-angular-alt-common';
import * as ɵngcc4 from '@progress/kendo-angular-buttons';

const _c0 = ["popup"];
const _c1 = ["anchor"];
function ToolbarItemComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} }
function ToolbarItemComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3, 4);
    ɵngcc0.ɵɵlistener("click", function ToolbarItemComponent_div_0_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onActionClick($event); });
    ɵngcc0.ɵɵtemplate(2, ToolbarItemComponent_div_0_div_2_Template, 2, 0, "div", 5);
    ɵngcc0.ɵɵelement(3, "ucc-icon", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isProcessing);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("key", ctx_r0.icon)("disabled", ctx_r0.isDisabled)("ngwkTooltip", ctx_r0.label)("ngwkTooltipPosition", ctx_r0.labelPosition);
} }
function ToolbarItemComponent_ngwk_popup_1_ng_container_2_button_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c2 = function (a0) { return { params: a0 }; };
function ToolbarItemComponent_ngwk_popup_1_ng_container_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵlistener("click", function ToolbarItemComponent_ngwk_popup_1_ng_container_2_button_1_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const toolbarItemComponent_r9 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.onToolbarItemChildClick(toolbarItemComponent_r9, $event); });
    ɵngcc0.ɵɵtemplate(1, ToolbarItemComponent_ngwk_popup_1_ng_container_2_button_1_ng_container_1_Template, 1, 0, "ng-container", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const toolbarItemComponent_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("id", toolbarItemComponent_r9.id)("disabled", toolbarItemComponent_r9.isDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r10.childTemplate || _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c2, toolbarItemComponent_r9.toolbarItemParams));
} }
function ToolbarItemComponent_ngwk_popup_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ToolbarItemComponent_ngwk_popup_1_ng_container_2_button_1_Template, 2, 6, "button", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const toolbarItemComponent_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", toolbarItemComponent_r9.isVisible);
} }
function ToolbarItemComponent_ngwk_popup_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ngwk-popup", 9);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵtemplate(2, ToolbarItemComponent_ngwk_popup_1_ng_container_2_Template, 2, 1, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("anchor", ctx_r1.anchor)("margin", ctx_r1.marginAlign)("anchorAlign", ctx_r1.anchorAlign)("popupAlign", ctx_r1.popupAlign);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.childrenToolbarItems);
} }
function ToolbarItemComponent_ng_template_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "ucc-icon", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const params_r16 = ɵngcc0.ɵɵnextContext().params;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("key", params_r16.icon);
} }
function ToolbarItemComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, ToolbarItemComponent_ng_template_2_div_1_Template, 2, 1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "div", 17);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const params_r16 = ctx.params;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", params_r16.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", params_r16.label, " ");
} }
const _c3 = ["collapsedToolbarItem"];
function ToolbarComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "ngwk-toolbar-item", 4, 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("checked", false);
} }
const _c4 = ["*"];
const _c5 = ["externalHoverlabel"];
const _c6 = ["externalLabel"];
function ButtonLauncherComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
} }
function ButtonLauncherComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7, 8);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.canDisplayExternalHoverLabel);
} }
function ButtonLauncherComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.hoverLabel, " ");
} }
function ButtonLauncherComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7, 9);
    ɵngcc0.ɵɵprojection(2, 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r3.canDisplayExternalHoverLabel);
} }
const _c7 = [[["label"]], [["hover-label"]]];
const _c8 = ["label", "hover-label"];
const _c9 = ["splitButton"];
const _c10 = ["splitButtonText"];
function SplitButtonComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", null, 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.buttonText);
} }
const _c11 = function (a0) { return { "width": a0 }; };
function SplitButtonComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelement(1, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(1, _c11, ctx_r2.contentButtonWidth));
} }
class ToolbarItemComponent {
    /** @ignore */
    constructor(_renderer, _elementRef, _cd) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._cd = _cd;
        this._isAlive = true;
        this._isMenuOpen = false;
        this._childrenToolbarItems = new Array();
        this._documentClickEventSubscription = null;
        this._documentKeyDownEventSubscription = null;
        this._anchorAlign = { horizontal: 'left', vertical: 'bottom' };
        this._popupAlign = { horizontal: 'left', vertical: 'top' };
        this._marginAlign = { horizontal: -70, vertical: 0 };
        this._childTemplate = null;
        this._actionClick = new EventEmitter();
        this._toolbarDisabled = false;
        this._toolbarItemParams = {
            tag: null,
            label: null,
            labelPosition: null,
            icon: null,
            visible: true,
            disabled: false,
            checked: null,
            isLoading: false,
            collapsedToolbarItem: false
        };
    }
    ngAfterContentInit() {
        // if contentToolbarItems === 1 is herself
        if (this._contentToolbarItems.length > 1) {
            this.checked = false;
            this.childrenToolbarItems = this.getChildToolbarItems();
        }
    }
    ngOnDestroy() {
        this._isAlive = false;
    }
    /** @ignore */
    onActionClick(event) {
        if (this.checked !== null) {
            this.checked = !this.checked;
        }
        this.checked && this.hasMenu ? this.onShowMenu() : this.onClose();
        this.actionClick.emit(event);
    }
    /** @ignore */
    onToolbarItemChildClick(toolbarItem, event) {
        if (toolbarItem) {
            toolbarItem.actionClick.emit(event);
        }
    }
    /** @ignore */
    onClose() {
        if (this.isMenuOpen) {
            this.checked = false;
            this.isMenuOpen = false;
            this._documentClickEventSubscription();
            this._documentKeyDownEventSubscription();
        }
    }
    /** @ignore */
    ownerToolbarDisabled(isDisabled) {
        this._toolbarDisabled = isDisabled;
        this.manageDisabledAttribute();
    }
    //#region Private Methods
    getChildToolbarItems() {
        return this._contentToolbarItems.filter(tbi => tbi !== this);
    }
    onShowMenu() {
        if (!this.isMenuOpen) {
            this.isMenuOpen = true;
            this._documentClickEventSubscription = this._renderer.listen('document', 'click', (event) => this.onDocumentClick(event));
            this._documentKeyDownEventSubscription = this._renderer.listen('document', 'keydown', (event) => this.onKeydown(event));
        }
    }
    contains(target) {
        return ((this.anchor && this.anchor.nativeElement.contains(target)) ||
            (this._popup && this._popup.nativeElement.contains(target)));
    }
    manageCheckedAttribute() {
        this.isChecked ? this._renderer.setAttribute(this._elementRef.nativeElement, 'checked', 'true') : this._renderer.removeAttribute(this._elementRef.nativeElement, 'checked');
    }
    manageDisabledAttribute() {
        this.isDisabled ? this._renderer.setAttribute(this._elementRef.nativeElement, 'disabled', 'true') : this._renderer.removeAttribute(this._elementRef.nativeElement, 'disabled');
    }
    onKeydown(event) {
        if (this.hasMenu && event.keyCode === 27) {
            this.onClose();
        }
    }
    onDocumentClick(event) {
        if (this.hasMenu && !this.contains(event.target)) {
            this.onClose();
        }
    }
    //#endregion
    //#region Properties
    /** @ignore */
    get collapsedToolbarItem() {
        return this._toolbarItemParams.collapsedToolbarItem;
    }
    /** @ignore */
    set collapsedToolbarItem(value) {
        let hasChanged = this._toolbarItemParams.collapsedToolbarItem !== value;
        this._toolbarItemParams.collapsedToolbarItem = value;
        if (hasChanged) {
            this._cd.detectChanges();
        }
    }
    /** @ignore */
    get isChecked() {
        return Type.getValue(this.checked);
    }
    /** @ignore */
    get hasMenu() {
        return this.childrenToolbarItems && this.childrenToolbarItems.length > 0;
    }
    /** @ignore */
    get anchor() {
        return this._anchor;
    }
    /** @ignore */
    get anchorAlign() {
        return this._anchorAlign;
    }
    /** @ignore */
    get popupAlign() {
        return this._popupAlign;
    }
    /** @ignore */
    get marginAlign() {
        return this._marginAlign;
    }
    /** @ignore */
    get isVisible() {
        return Type.getValue(this.visible);
    }
    /** @ignore */
    get isDisabled() {
        return Type.getValue(this.disabled) || this._toolbarDisabled;
    }
    /** @ignore */
    get isProcessing() {
        return Type.getValue(this.isLoading);
    }
    /** @ignore */
    get isCollapsedToolbarItem() {
        return Type.getValue(this.collapsedToolbarItem);
    }
    /** @ignore */
    get toolbarItemParams() {
        return this._toolbarItemParams;
    }
    /** @ignore */
    get id() {
        return this._elementRef.nativeElement.id;
    }
    /** @ignore */
    get childrenToolbarItems() {
        return this._childrenToolbarItems;
    }
    /** @ignore */
    set childrenToolbarItems(value) {
        this._childrenToolbarItems = value;
    }
    //#region Inputs
    /**
     * Permite obtener el tag identificador del ToolbarItem
     */
    get tag() {
        return this._toolbarItemParams.tag;
    }
    /**
     * Permite definir el tag identificador del ToolbarItem
     *
     * @param value El tag identificador del ToolbarItem
     */
    set tag(value) {
        this._toolbarItemParams.tag = value;
    }
    /**
     * Permite obtener la label del ToolbarItem, que se mostrará a modo de Tooltip o a modo del label si pertenece dentro de un Extended Toolbar Item
     */
    get label() {
        return this._toolbarItemParams.label;
    }
    /**
     * Permite definir la label del ToolbarItem, que se mostrará a modo de Tooltip o a modo del label si pertenece dentro de un Extended Toolbar Item
     * @param value La label del ToolbarItem
     */
    set label(value) {
        this._toolbarItemParams.label = value;
    }
    /**
     * Permite obtener la posición del tooltip del Toolbar Item
     */
    get labelPosition() {
        return this._toolbarItemParams.labelPosition;
    }
    /**
     * Permite definir la posición del tooltip del Toolbar Item
     *
     * @param value La posición del tooltip del Toolbar Item
     */
    set labelPosition(value) {
        this._toolbarItemParams.labelPosition = value;
    }
    /**
     * Permite obtener el icono del ToolbarItem
     */
    get icon() {
        return this._toolbarItemParams.icon;
    }
    /**
     * Permite definir el icono del ToolbarItem
     *
     * @param value El icono del ToolbarItem
     */
    set icon(value) {
        this._toolbarItemParams.icon = value;
    }
    /**
     * Permite consultar si el estado de visible del ToolbarItem está activado o desactivado
     */
    get visible() {
        return this._toolbarItemParams.visible;
    }
    /**
     * Permite activar o desactivar el estado de visible del ToolbarItem
     *
     * @param value Valor que activa o desactiva el estado de visible del ToolbarItem
     */
    set visible(value) {
        this._toolbarItemParams.visible = value;
    }
    /**
     * Permite consultar si el estado de deshabilitado del ToolbarItem está activado o desactivado
     */
    get disabled() {
        return this._toolbarItemParams.disabled;
    }
    /**
     * Permite activar o desactivar el estado de deshabilitado del ToolbarItem
     *
     * @param value Valor que activa o desactiva el estado de deshabilitado del ToolbarItem
     */
    set disabled(value) {
        this._toolbarItemParams.disabled = value;
        this.manageDisabledAttribute();
    }
    /**
     * Permite consultar si el estado de cargando del ToolbarItem está activado o desactivado
     */
    get isLoading() {
        return this._toolbarItemParams.isLoading;
    }
    /**
     * Permite activar o desactivar el estado de cargando del ToolbarItem
     *
     * @param value Valor que activa o desactiva el estado de cargando del ToolbarItem
     */
    set isLoading(value) {
        this._toolbarItemParams.isLoading = value;
    }
    /**
     * Permite consultar si el estado de checked del ToolbarItem está activado o desactivado
     */
    get checked() {
        return this._toolbarItemParams.checked;
    }
    /**
     * Permite activar o desactivar el estado de checked del ToolbarItem
     *
     * @param value Valor que activa o desactiva el estado de checked del ToolbarItem
     */
    set checked(value) {
        this._toolbarItemParams.checked = value;
        this.manageCheckedAttribute();
    }
    /**
     * Permite consultar el estado del desplegable del submenu del ToolbarItem
     */
    get isMenuOpen() {
        return this._isMenuOpen;
    }
    /**
     * Permite activar o desactivar el desplegable del submenu del ToolbarItem en el caso de que sea de tipo extended
     *
     * @param value Valor que activa o desactiva el desplegable del submenu del ToolbarItem
     */
    set isMenuOpen(value) {
        let hasChanged = this._isMenuOpen !== value;
        this._isMenuOpen = value;
        if (this._isAlive && hasChanged) {
            this._cd.detectChanges();
        }
    }
    /**
     * Permite obtener la template customizada del ExtendedToolbarItem y que se aplicará a los hijos que éste tenga
     */
    get childTemplate() {
        return this._childTemplate;
    }
    /**
     * Permite definir la template customizada del ExtendedToolbarItem y que se aplicará a los hijos que éste tenga
     *
     * @param value La template customizada del ExtendedToolbarItem
     */
    set childTemplate(value) {
        this._childTemplate = value;
    }
    //#endregion
    //#region Output
    /**
     * Emite un evento cuando se ha hecho click al ToolbarItem
     */
    get actionClick() {
        return this._actionClick;
    }
}
ToolbarItemComponent.ɵfac = function ToolbarItemComponent_Factory(t) { return new (t || ToolbarItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ToolbarItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToolbarItemComponent, selectors: [["ngwk-toolbar-item"]], contentQueries: function ToolbarItemComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ToolbarItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._contentToolbarItems = _t);
    } }, viewQuery: function ToolbarItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c1, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._popup = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._anchor = _t.first);
    } }, inputs: { checked: "checked", isMenuOpen: "isMenuOpen", tag: "tag", label: "label", labelPosition: "labelPosition", icon: "icon", visible: "visible", disabled: "disabled", isLoading: "isLoading", childTemplate: "childTemplate" }, outputs: { actionClick: "actionClick" }, decls: 4, vars: 2, consts: [[3, "click", 4, "ngIf"], [3, "anchor", "margin", "anchorAlign", "popupAlign", 4, "ngIf"], ["defaultChildTemplate", ""], [3, "click"], ["anchor", ""], ["class", "loadingAnimationButton", 4, "ngIf"], [1, "alignMiddle", "loadingSpinner", 3, "key", "disabled", "ngwkTooltip", "ngwkTooltipPosition"], [1, "loadingAnimationButton"], [1, "loadingSpinner"], [3, "anchor", "margin", "anchorAlign", "popupAlign"], [1, "verticalLayout", "menuPopupContent"], [4, "ngFor", "ngForOf"], ["class", "toolbarItemComponent", 3, "id", "disabled", "click", 4, "ngIf"], [1, "toolbarItemComponent", 3, "id", "disabled", "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "horizontalLayout"], [4, "ngIf"], [1, "alignMiddle"], [1, "alignMiddle", 3, "key"]], template: function ToolbarItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ToolbarItemComponent_div_0_Template, 4, 5, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ToolbarItemComponent_ngwk_popup_1_Template, 3, 5, "ngwk-popup", 1);
        ɵngcc0.ɵɵtemplate(2, ToolbarItemComponent_ng_template_2_Template, 4, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isVisible && !ctx.isCollapsedToolbarItem);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMenuOpen);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.IconComponent, ɵngcc3.NgwkTooltipDirective, ɵngcc3.PopupComponent, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
ToolbarItemComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
ToolbarItemComponent.propDecorators = {
    _contentToolbarItems: [{ type: ContentChildren, args: [ToolbarItemComponent,] }],
    _popup: [{ type: ViewChild, args: ['popup', { read: ElementRef },] }],
    _anchor: [{ type: ViewChild, args: ['anchor', { read: ElementRef },] }],
    tag: [{ type: Input }],
    label: [{ type: Input }],
    labelPosition: [{ type: Input }],
    icon: [{ type: Input }],
    visible: [{ type: Input }],
    disabled: [{ type: Input }],
    isLoading: [{ type: Input }],
    checked: [{ type: Input }],
    isMenuOpen: [{ type: Input }],
    childTemplate: [{ type: Input }],
    actionClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToolbarItemComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-toolbar-item',
                template: "<div #anchor *ngIf=\"isVisible && !isCollapsedToolbarItem\" (click)=\"onActionClick($event)\">\r\n  <div *ngIf=\"isProcessing\" class=\"loadingAnimationButton\">\r\n    <div class=\"loadingSpinner\"></div>\r\n  </div>\r\n  <ucc-icon [key]='icon' class='alignMiddle loadingSpinner' [disabled]=\"isDisabled\" [ngwkTooltip]=\"label\"\r\n    [ngwkTooltipPosition]=\"labelPosition\">\r\n  </ucc-icon>\r\n</div>\r\n\r\n<ngwk-popup *ngIf=\"isMenuOpen\" \r\n  [anchor]=\"anchor\" \r\n  [margin]=\"marginAlign\" \r\n  [anchorAlign]=\"anchorAlign\"\r\n  [popupAlign]=\"popupAlign\">\r\n    <div class=\"verticalLayout menuPopupContent\">\r\n      <ng-container *ngFor=\"let toolbarItemComponent of childrenToolbarItems\">\r\n        <button *ngIf=\"toolbarItemComponent.isVisible\" \r\n          [id]=\"toolbarItemComponent.id\"\r\n          class=\"toolbarItemComponent\"\r\n          [disabled]=\"toolbarItemComponent.isDisabled\"\r\n          (click)='onToolbarItemChildClick(toolbarItemComponent, $event)'>                   \r\n          <ng-container\r\n            *ngTemplateOutlet=\"childTemplate || defaultChildTemplate; context: { params: toolbarItemComponent.toolbarItemParams }\">\r\n          </ng-container>\r\n        </button>\r\n      </ng-container>\r\n    </div>\r\n</ngwk-popup>\r\n\r\n<ng-template #defaultChildTemplate let-params=\"params\">\r\n  <div class=\"horizontalLayout\">\r\n    <div *ngIf=\"params.icon\">\r\n      <ucc-icon class='alignMiddle' [key]='params.icon'></ucc-icon>\r\n    </div>\r\n    <div class=\"alignMiddle\">\r\n      {{params.label}}\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { checked: [{
            type: Input
        }], isMenuOpen: [{
            type: Input
        }], tag: [{
            type: Input
        }], label: [{
            type: Input
        }], labelPosition: [{
            type: Input
        }], icon: [{
            type: Input
        }], visible: [{
            type: Input
        }], disabled: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], childTemplate: [{
            type: Input
        }], actionClick: [{
            type: Output
        }], _contentToolbarItems: [{
            type: ContentChildren,
            args: [ToolbarItemComponent]
        }], _popup: [{
            type: ViewChild,
            args: ['popup', { read: ElementRef }]
        }], _anchor: [{
            type: ViewChild,
            args: ['anchor', { read: ElementRef }]
        }] }); })();

/**
 * Este componente funciona a modo de contenedor, donde se le declara una serie de [ToolbarItemComponents]{@link ToolbarItemComponent},
 * todos y cada uno de ellos con su propia configuración
 *
 * @example
 * <ngwk-toolbar>
 *      <ngwk-toolbar-item [label]='label' [labelPosition]='position' [icon]='icon' (click)='function()' [checked]='checked' [visible]='visible' [disabled]='disabled'></ngwk-toolbar-item>
 *      <ngwk-toolbar-item [label]='label' [labelPosition]='position' [icon]='icon' (click)='function()' [checked]='checked' [visible]='visible' [disabled]='disabled'></ngwk-toolbar-item>
 *      <ngwk-toolbar-item [label]='label' [labelPosition]='position' [icon]='icon' (click)='function()' [checked]='checked' [visible]='visible' [disabled]='disabled'></ngwk-toolbar-item>
 * </ngwk-toolbar>
 */
class ToolbarComponent {
    constructor() {
        this._maxItems = null;
        this._collapsedToolbarItems = new Array();
        this._disabled = false;
        //#endregion
        //#endregion
    }
    ngAfterContentInit() {
        if (this.isInit && this.maxItems) {
            this.createCollapsedToolbar();
        }
    }
    ngAfterContentChecked() {
        if (this.isInit && this.maxItems) {
            this.resetCollapsedToolbar();
            this.createCollapsedToolbar();
        }
    }
    //#region Private Methods
    resetCollapsedToolbar() {
        this._collapsedToolbarItems = [];
        this._allToolbarItems.forEach((toolbarItem) => toolbarItem.collapsedToolbarItem = false);
    }
    createCollapsedToolbar() {
        if (this._allToolbarItems.length >= this.maxItems) {
            const allToolbarItems = this._allToolbarItems.toArray();
            const displayedToolbarItems = allToolbarItems.filter((toolbarItem) => toolbarItem.hasMenu && toolbarItem.visible);
            displayedToolbarItems.forEach((toolbarItem) => toolbarItem.collapsedToolbarItem = false);
            for (let index = 0; displayedToolbarItems.length < this.maxItems && index < allToolbarItems.length; ++index) {
                if (!allToolbarItems[index].hasMenu && allToolbarItems[index].visible) {
                    allToolbarItems[index].collapsedToolbarItem = false;
                    displayedToolbarItems.push(allToolbarItems[index]);
                }
            }
            this._collapsedToolbarItems = allToolbarItems.filter((toolbarItem) => !displayedToolbarItems.some(dti => dti === toolbarItem));
            this._collapsedToolbarItems.forEach((toolbarItem) => toolbarItem.collapsedToolbarItem = true);
            this.setChildrenToolbarItems();
        }
    }
    setChildrenToolbarItems() {
        if (this._collapsedToolbarItem) {
            this._collapsedToolbarItem.childrenToolbarItems = this._collapsedToolbarItems;
        }
    }
    manageDisabledState(isDisabled) {
        if (this.isInit) {
            this._allToolbarItems.forEach((toolbarItem) => toolbarItem.ownerToolbarDisabled(isDisabled));
        }
    }
    //#endregion
    //#region Properties
    /** @ignore */
    get hasCollapsedToolbarItems() {
        return this.maxItems !== 0 &&
            this._collapsedToolbarItems.length > 0 &&
            this._collapsedToolbarItems.some((toolbarItem) => toolbarItem.isVisible);
    }
    /** @ignore */
    get isInit() {
        return this._allToolbarItems ? true : false;
    }
    /** Permite obtener los ToolbarItemComponent definidos en el Toolbar */
    get toolbarItems() {
        return this._allToolbarItems;
    }
    /** @ignore */
    get collapsedToolbarItems() {
        return this._collapsedToolbarItems;
    }
    //#region Inputs
    /**
     * Permite obtener el número máximo de elementos.
     */
    get maxItems() {
        return this._maxItems;
    }
    /**
     * Permite definir el número máximo de elementos a mostrar en la toolbar. El resto se muestran con un desplegable.
     *
     * @param value Número máximo de elementos a mostrar en la toolbar.
     */
    set maxItems(value) {
        this._maxItems = value;
    }
    /**
     * Permite consultar el estado de deshabilitado de todos los [ToolbarItem]{@link ToolbarItemComponent} de la Toolbar
     */
    get disabled() {
        return this._disabled;
    }
    /**
     * Permite deshabilitar o habilitar todos los [ToolbarItem]{@link ToolbarItemComponent} de la Toolbar
     *
     * @param value Valor que activa o desactiva todos los ToolbarItem
     */
    set disabled(value) {
        this._disabled = value;
        this.manageDisabledState(value);
    }
}
ToolbarComponent.ɵfac = function ToolbarComponent_Factory(t) { return new (t || ToolbarComponent)(); };
ToolbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToolbarComponent, selectors: [["ngwk-toolbar"]], contentQueries: function ToolbarComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ToolbarItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._allToolbarItems = _t);
    } }, viewQuery: function ToolbarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._collapsedToolbarItem = _t.first);
    } }, inputs: { maxItems: "maxItems", disabled: "disabled" }, ngContentSelectors: _c4, decls: 5, vars: 1, consts: [[1, "horizontalLayout"], [1, "wkToolbar", "alignMiddle"], ["toolbar", ""], [4, "ngIf"], ["id", "tbiShowCollapsedItems", "icon", "moreIcon", 3, "checked"], ["collapsedToolbarItem", ""]], template: function ToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, ToolbarComponent_div_4_Template, 3, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasCollapsedToolbarItems);
    } }, directives: [ɵngcc1.NgIf, ToolbarItemComponent], styles: ["[_nghost-%COMP%]     .wkToolbar{float:left;margin:0;display:flex}[_nghost-%COMP%]     .loadingAnimationButton .loadingSpinner{position:absolute;box-sizing:content-box;margin-left:1px;margin-top:-1px;border:2px solid #666;border-top-color:#0000;border-left-color:#0000;width:26px;height:26px;opacity:1;animation:loadingSpinner 1.2s infinite linear;-webkit-animation:loadingSpinner 1.2s infinite linear}[_nghost-%COMP%]     ngwk-f2-box-shadowcsshost-no-combinator   ngwk-toolbar-item ucc-icon, ngwk-f2-box   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon{padding:0!important}[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon{color:#666;border:0px;border-radius:50%;cursor:pointer;overflow:hidden;outline:none;margin:0 2px;padding:4px}[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:hover{background-color:#eee}[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:active{background-color:#666;color:#fff}[_nghost-%COMP%]     ngwk-toolbar-item kendo-popup{margin-left:59px!important}[_nghost-%COMP%]     ngwk-toolbar-item[disabled]{opacity:.5;background-color:transparent;cursor:default;pointer-events:none}[_nghost-%COMP%]     ngwk-toolbar-item[checked] ucc-icon{background-color:#666;color:#fff;border-radius:50%}[_nghost-%COMP%]     ngwk-toolbar-item[checked] .loadingAnimationButton .loadingSpinner{border-width:3px;margin-left:0;margin-top:-2px}[_nghost-%COMP%]     ngwk-toolbar-item[checked] kendo-popup ucc-icon{background-color:transparent!important;color:#666!important}[_nghost-%COMP%]     .toolbarHeight{height:35px;margin:10px 0!important;display:flex;align-items:center}.toolBarContextual[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon, .toolBarContextual   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon{color:#fa9200!important}.toolBarContextual[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:active, .toolBarContextual   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:active{color:#fff!important}.toolbarFieldset[_nghost-%COMP%]     .wkToolbar, .toolbarFieldset   [_nghost-%COMP%]     .wkToolbar{margin-left:10px}.toolbarFieldset[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon, .toolbarFieldset   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon, .toolbarListTitle[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon, .toolbarListTitle   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon{color:#666}.toolbarFieldset[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:hover, .toolbarFieldset   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:hover, .toolbarListTitle[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:hover, .toolbarListTitle   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:hover{background-color:#eee}.toolbarFieldset[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:active, .toolbarFieldset   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:active, .toolbarListTitle[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:active, .toolbarListTitle   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:active{background-color:#e6742e;color:#fff}.toolbarFieldset[_nghost-%COMP%]     ngwk-toolbar-item .loadingAnimationButton .loadingSpinner, .toolbarFieldset   [_nghost-%COMP%]     ngwk-toolbar-item .loadingAnimationButton .loadingSpinner, .toolbarListTitle[_nghost-%COMP%]     ngwk-toolbar-item .loadingAnimationButton .loadingSpinner, .toolbarListTitle   [_nghost-%COMP%]     ngwk-toolbar-item .loadingAnimationButton .loadingSpinner{border-color:#e6742e;border-top-color:#0000;border-left-color:#0000}.toolbarFieldset[_nghost-%COMP%]     ngwk-toolbar-item[disabled] ucc-icon, .toolbarFieldset   [_nghost-%COMP%]     ngwk-toolbar-item[disabled] ucc-icon, .toolbarListTitle[_nghost-%COMP%]     ngwk-toolbar-item[disabled] ucc-icon, .toolbarListTitle   [_nghost-%COMP%]     ngwk-toolbar-item[disabled] ucc-icon{opacity:.5;background-color:transparent;cursor:default;pointer-events:none}.toolbarFieldset[_nghost-%COMP%]     ngwk-toolbar-item[checked] ucc-icon, .toolbarFieldset   [_nghost-%COMP%]     ngwk-toolbar-item[checked] ucc-icon, .toolbarListTitle[_nghost-%COMP%]     ngwk-toolbar-item[checked] ucc-icon, .toolbarListTitle   [_nghost-%COMP%]     ngwk-toolbar-item[checked] ucc-icon{background-color:#e6742e;color:#fff}.actionBar[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon, .actionBar   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon{background-color:#eee;color:#0081c6}.actionBar[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:hover, .actionBar   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:hover{background-color:#0081c6;color:#fff}.actionBar[_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:active, .actionBar   [_nghost-%COMP%]     ngwk-toolbar-item ucc-icon:active{background-color:#0081c6;color:#fff}.actionBar[_nghost-%COMP%]     ngwk-toolbar-item .loadingAnimationButton .loadingSpinner, .actionBar   [_nghost-%COMP%]     ngwk-toolbar-item .loadingAnimationButton .loadingSpinner{border-color:#0081c6;border-top-color:#0000;border-left-color:#0000}.actionBar[_nghost-%COMP%]     ngwk-toolbar-item[checked] ucc-icon, .actionBar   [_nghost-%COMP%]     ngwk-toolbar-item[checked] ucc-icon{background-color:#0081c6;color:#fff}"] });
ToolbarComponent.propDecorators = {
    _collapsedToolbarItem: [{ type: ViewChild, args: ['collapsedToolbarItem',] }],
    _allToolbarItems: [{ type: ContentChildren, args: [ToolbarItemComponent,] }],
    maxItems: [{ type: Input }],
    disabled: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-toolbar',
                template: "<div class=\"horizontalLayout\">\r\n    <div #toolbar class=\"wkToolbar alignMiddle\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n    <div *ngIf=\"hasCollapsedToolbarItems\">\r\n        <ngwk-toolbar-item #collapsedToolbarItem\r\n            id=\"tbiShowCollapsedItems\"\r\n            icon='moreIcon'\r\n            [checked]=\"false\">\r\n        </ngwk-toolbar-item>\r\n    </div>\r\n</div>\r\n",
                styles: [":host ::ng-deep .wkToolbar{float:left;margin:0;display:flex}:host ::ng-deep .loadingAnimationButton .loadingSpinner{position:absolute;box-sizing:content-box;margin-left:1px;margin-top:-1px;border:2px solid #666;border-top-color:#0000;border-left-color:#0000;width:26px;height:26px;opacity:1;animation:loadingSpinner 1.2s infinite linear;-webkit-animation:loadingSpinner 1.2s infinite linear}:host ::ng-deep :host-context(ngwk-f2-box) ::ng-deep ngwk-toolbar-item ucc-icon{padding:0!important}:host ::ng-deep ngwk-toolbar-item ucc-icon{color:#666;border:0px;border-radius:50%;cursor:pointer;overflow:hidden;outline:none;margin:0 2px;padding:4px}:host ::ng-deep ngwk-toolbar-item ucc-icon:hover{background-color:#eee}:host ::ng-deep ngwk-toolbar-item ucc-icon:active{background-color:#666;color:#fff}:host ::ng-deep ngwk-toolbar-item kendo-popup{margin-left:59px!important}:host ::ng-deep ngwk-toolbar-item[disabled]{opacity:.5;background-color:transparent;cursor:default;pointer-events:none}:host ::ng-deep ngwk-toolbar-item[checked] ucc-icon{background-color:#666;color:#fff;border-radius:50%}:host ::ng-deep ngwk-toolbar-item[checked] .loadingAnimationButton .loadingSpinner{border-width:3px;margin-left:0;margin-top:-2px}:host ::ng-deep ngwk-toolbar-item[checked] kendo-popup ucc-icon{background-color:transparent!important;color:#666!important}:host ::ng-deep .toolbarHeight{height:35px;margin:10px 0!important;display:flex;align-items:center}:host-context(.toolBarContextual) ::ng-deep ngwk-toolbar-item ucc-icon{color:#fa9200!important}:host-context(.toolBarContextual) ::ng-deep ngwk-toolbar-item ucc-icon:active{color:#fff!important}:host-context(.toolbarFieldset) ::ng-deep .wkToolbar{margin-left:10px}:host-context(.toolbarFieldset) ::ng-deep ngwk-toolbar-item ucc-icon,:host-context(.toolbarListTitle) ::ng-deep ngwk-toolbar-item ucc-icon{color:#666}:host-context(.toolbarFieldset) ::ng-deep ngwk-toolbar-item ucc-icon:hover,:host-context(.toolbarListTitle) ::ng-deep ngwk-toolbar-item ucc-icon:hover{background-color:#eee}:host-context(.toolbarFieldset) ::ng-deep ngwk-toolbar-item ucc-icon:active,:host-context(.toolbarListTitle) ::ng-deep ngwk-toolbar-item ucc-icon:active{background-color:#e6742e;color:#fff}:host-context(.toolbarFieldset) ::ng-deep ngwk-toolbar-item .loadingAnimationButton .loadingSpinner,:host-context(.toolbarListTitle) ::ng-deep ngwk-toolbar-item .loadingAnimationButton .loadingSpinner{border-color:#e6742e;border-top-color:#0000;border-left-color:#0000}:host-context(.toolbarFieldset) ::ng-deep ngwk-toolbar-item[disabled] ucc-icon,:host-context(.toolbarListTitle) ::ng-deep ngwk-toolbar-item[disabled] ucc-icon{opacity:.5;background-color:transparent;cursor:default;pointer-events:none}:host-context(.toolbarFieldset) ::ng-deep ngwk-toolbar-item[checked] ucc-icon,:host-context(.toolbarListTitle) ::ng-deep ngwk-toolbar-item[checked] ucc-icon{background-color:#e6742e;color:#fff}:host-context(.actionBar) ::ng-deep ngwk-toolbar-item ucc-icon{background-color:#eee;color:#0081c6}:host-context(.actionBar) ::ng-deep ngwk-toolbar-item ucc-icon:hover{background-color:#0081c6;color:#fff}:host-context(.actionBar) ::ng-deep ngwk-toolbar-item ucc-icon:active{background-color:#0081c6;color:#fff}:host-context(.actionBar) ::ng-deep ngwk-toolbar-item .loadingAnimationButton .loadingSpinner{border-color:#0081c6;border-top-color:#0000;border-left-color:#0000}:host-context(.actionBar) ::ng-deep ngwk-toolbar-item[checked] ucc-icon{background-color:#0081c6;color:#fff}\n"]
            }]
    }], function () { return []; }, { maxItems: [{
            type: Input
        }], disabled: [{
            type: Input
        }], _collapsedToolbarItem: [{
            type: ViewChild,
            args: ['collapsedToolbarItem']
        }], _allToolbarItems: [{
            type: ContentChildren,
            args: [ToolbarItemComponent]
        }] }); })();

class ToolbarModule {
}
ToolbarModule.ɵfac = function ToolbarModule_Factory(t) { return new (t || ToolbarModule)(); };
ToolbarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ToolbarModule });
ToolbarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            IconModule,
            TooltipModule,
            PopupModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToolbarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IconModule,
                    TooltipModule,
                    PopupModule
                ],
                declarations: [
                    ToolbarComponent,
                    ToolbarItemComponent
                ],
                exports: [
                    ToolbarComponent,
                    ToolbarItemComponent
                ],
                schemas: [
                    CUSTOM_ELEMENTS_SCHEMA
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ToolbarModule, { declarations: function () { return [ToolbarComponent, ToolbarItemComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        IconModule,
        TooltipModule,
        PopupModule]; }, exports: function () { return [ToolbarComponent, ToolbarItemComponent]; } }); })();

/**
 * Esta clase aporta las funciones para la directiva del tipo de botón "Progress Button". Esta directiva sirve para poder poner
 * un botón en estado de 'loading' (true), haciendo que se deshabilite hasta que el usuario lo vuelva a poner en estado de
 * 'no loading' (false)
 *
 */
class ProgressButtonDirective {
    /** @ignore */
    constructor(el, renderer2) {
        this.el = el;
        this.renderer2 = renderer2;
        this._isLoading = false;
        this._isInit = false;
    }
    /** @ignore */
    ngAfterViewInit() {
        this._contentText = this.el.nativeElement.textContent;
        this.createDefaultElement();
        this.createLoadingElement();
        this._isInit = true;
    }
    createLoadingElement() {
        this._laodingElement = this.renderer2.createElement('div');
        this.renderer2.addClass(this._laodingElement, 'loadingSpinner');
    }
    createDefaultElement() {
        this._defaultElement = this.renderer2.createText(`${this._contentText}`);
    }
    manageButtonState() {
        if (this._isInit) {
            if (this.isLoading) {
                let _originalWidth = this.el.nativeElement.getBoundingClientRect().width;
                this.renderer2.setStyle(this.el.nativeElement, 'width', `${_originalWidth}px`);
                this.setTemplate(this._laodingElement);
                this.renderer2.addClass(this.el.nativeElement, BUTTON_ANIMATION_CLASS);
            }
            else {
                this.renderer2.removeClass(this.el.nativeElement, BUTTON_ANIMATION_CLASS);
                this.setTemplate(this._defaultElement);
                this.renderer2.removeStyle(this.el.nativeElement, 'width');
            }
        }
    }
    setTemplate(template) {
        this.cleanChilds();
        this.renderer2.appendChild(this.el.nativeElement, template);
    }
    cleanChilds() {
        while (this.el.nativeElement.firstChild) {
            this.el.nativeElement.removeChild(this.el.nativeElement.firstChild);
        }
    }
    /**
     * Permite activar o desactivar el estado de cargando del botón que tiene esta directiva
     *
     * @param value Valor que activa o desactiva el estado de cargando
     */
    set isLoading(value) {
        this._isLoading = value;
        this.manageButtonState();
    }
    /**
     * Permite consultar el estado de cargando del botón que tiene esta directiva
     */
    get isLoading() {
        return this._isLoading;
    }
}
ProgressButtonDirective.ɵfac = function ProgressButtonDirective_Factory(t) { return new (t || ProgressButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ProgressButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ProgressButtonDirective, selectors: [["", "ngWKProgressButton", ""]], inputs: { isLoading: ["ngWKProgressButton", "isLoading"] } });
/** @nocollapse */
ProgressButtonDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
ProgressButtonDirective.propDecorators = {
    isLoading: [{ type: Input, args: ['ngWKProgressButton',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressButtonDirective, [{
        type: Directive,
        args: [{
                selector: '[ngWKProgressButton]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { isLoading: [{
            type: Input,
            args: ['ngWKProgressButton']
        }] }); })();
/** @ignore */
const BUTTON_ANIMATION_CLASS = 'loadingAnimationButton';

class ProgressButtonModule {
}
ProgressButtonModule.ɵfac = function ProgressButtonModule_Factory(t) { return new (t || ProgressButtonModule)(); };
ProgressButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ProgressButtonModule });
ProgressButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressButtonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    ProgressButtonDirective
                ],
                exports: [
                    ProgressButtonDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ProgressButtonModule, { declarations: function () { return [ProgressButtonDirective]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [ProgressButtonDirective]; } }); })();

/**
 * Este componente contiene un texto que se muestra en todo momento y, de igual forma, otro texto que únicamente se muestra
 * al pasar el ratón por encima. También contiene un icono.
 * Si en vez de texto se quiere añadir un componente (tanto normal como hover), se pueden definir como elementos hijos,
 * teniendo en cuenta que se ha de agregar el atributo "label" o "hover-label" en el elemento padre, para que el componente
 * sepa dónde lo tiene que situar. Se ha de tener en cuenta que si se define tanto un texto mediante el atributo label o hoverLabel y, además, se
 * añade un template, se mostrarán ambos.
 *
 * @example
 * <ngwk-button-launcher [label]="label" [hoverLabel]="hoverLabel" [icon]="icon">
 *     <label>...</label>
 *     <hover-label>...</hover-label>
 * </ngwk-button-launcher>
 */
class ButtonLauncherComponent {
    constructor() {
        /**
         * Define el texto que se muestra en el Button Launcher Component cuando el Mouse no está por encima
         */
        this.label = null;
        /**
         * Define el texto que se muestra en el Button Launcher Component cuando el Mouse está por encima
         */
        this.hoverLabel = null;
        /**
         * Nombre del icono que se muestra en el Button Launcher Component
         */
        this.icon = null;
        /**
         * Clase css que se aplicará al icono de manera opcional
         */
        this.iconClass = null;
        this.externalLabelExists = true;
        this.externalHoverLabelExists = true;
        this._isMouseOver = false;
        this._externalHoverLabel = null;
        this._externalLabel = null;
    }
    ngAfterContentInit() {
        setTimeout(() => {
            this.externalLabelExists = this.showExternalContent(this._externalLabel);
            this.externalHoverLabelExists = this.showExternalContent(this._externalHoverLabel);
        });
    }
    /** @ignore */
    onMouseOver() {
        this._isMouseOver = true;
    }
    /** @ignore */
    onMouseOut() {
        this._isMouseOver = false;
    }
    /** @ignore */
    get canDisplayLabel() {
        return !this._isMouseOver && this.label !== null;
    }
    /** @ignore */
    get canDisplayHoverLabel() {
        return this._isMouseOver && this.hoverLabel !== null;
    }
    /** @ignore */
    get canDisplayExternalLabel() {
        return !this._isMouseOver && this.externalLabelExists;
    }
    /** @ignore */
    get canDisplayExternalHoverLabel() {
        return this._isMouseOver && this.externalHoverLabelExists;
    }
    showExternalContent(externalContent) {
        return externalContent && !!externalContent.nativeElement.firstElementChild;
    }
}
ButtonLauncherComponent.ɵfac = function ButtonLauncherComponent_Factory(t) { return new (t || ButtonLauncherComponent)(); };
ButtonLauncherComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonLauncherComponent, selectors: [["ngwk-button-launcher"]], viewQuery: function ButtonLauncherComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, 5);
        ɵngcc0.ɵɵviewQuery(_c6, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._externalHoverLabel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._externalLabel = _t.first);
    } }, hostBindings: function ButtonLauncherComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseover", function ButtonLauncherComponent_mouseover_HostBindingHandler() { return ctx.onMouseOver(); })("mouseleave", function ButtonLauncherComponent_mouseleave_HostBindingHandler() { return ctx.onMouseOut(); });
    } }, inputs: { label: "label", hoverLabel: "hoverLabel", icon: "icon", iconClass: "iconClass" }, ngContentSelectors: _c8, decls: 7, vars: 6, consts: [[1, "launcherContainer", "colorizeIconByKey", "alignVerticalMiddle"], [3, "key", "iconClass"], [1, "launcherTextContent", "truncateText"], ["class", "truncateText", 4, "ngIf"], [3, "hidden", 4, "ngIf"], [4, "ngIf"], [1, "truncateText"], [3, "hidden"], ["externalLabel", ""], ["externalHoverlabel", ""]], template: function ButtonLauncherComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "ucc-icon", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, ButtonLauncherComponent_span_3_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵtemplate(4, ButtonLauncherComponent_div_4_Template, 3, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(5, ButtonLauncherComponent_span_5_Template, 2, 1, "span", 5);
        ɵngcc0.ɵɵtemplate(6, ButtonLauncherComponent_div_6_Template, 3, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("key", ctx.icon)("iconClass", ctx.iconClass);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.canDisplayLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.externalLabelExists);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.canDisplayHoverLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.externalHoverLabelExists);
    } }, directives: [ɵngcc2.IconComponent, ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]     .launcherContainer{padding:10px}[_nghost-%COMP%]     .launcherContainer ucc-icon{opacity:.6}[_nghost-%COMP%]     .launcherContainer:hover{background-color:#f5f5f5;border-radius:25px;cursor:pointer}[_nghost-%COMP%]     .launcherContainer:hover ucc-icon{opacity:1}[_nghost-%COMP%]     .launcherContainer:hover span, [_nghost-%COMP%]     .launcherContainer:hover a{font-family:\"FiraSans SemiBold\"}[_nghost-%COMP%]     .launcherTextContent{width:100%;margin-left:8px;color:#373737;font-size:13px}"] });
ButtonLauncherComponent.propDecorators = {
    label: [{ type: Input }],
    hoverLabel: [{ type: Input }],
    icon: [{ type: Input }],
    iconClass: [{ type: Input }],
    _externalHoverLabel: [{ type: ViewChild, args: ['externalHoverlabel',] }],
    _externalLabel: [{ type: ViewChild, args: ['externalLabel',] }],
    onMouseOver: [{ type: HostListener, args: ['mouseover',] }],
    onMouseOut: [{ type: HostListener, args: ['mouseleave',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonLauncherComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-button-launcher',
                template: "<div class=\"launcherContainer colorizeIconByKey alignVerticalMiddle\">\r\n    <ucc-icon [key]='icon' [iconClass]=\"iconClass\"></ucc-icon>\r\n\r\n    <div class=\"launcherTextContent truncateText\">\r\n        <span *ngIf=\"canDisplayLabel\" class=\"truncateText\">\r\n            {{ label }}\r\n        </span>\r\n        <div #externalLabel *ngIf=\"externalLabelExists\" [hidden]=\"canDisplayExternalHoverLabel\">\r\n            <ng-content select=\"label\"></ng-content>\r\n        </div>\r\n\r\n        <span *ngIf=\"canDisplayHoverLabel\">\r\n            {{ hoverLabel }}\r\n        </span>\r\n        <div #externalHoverlabel *ngIf=\"externalHoverLabelExists\" [hidden]=\"!canDisplayExternalHoverLabel\">\r\n            <ng-content select=\"hover-label\"></ng-content>\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [":host ::ng-deep .launcherContainer{padding:10px}:host ::ng-deep .launcherContainer ucc-icon{opacity:.6}:host ::ng-deep .launcherContainer:hover{background-color:#f5f5f5;border-radius:25px;cursor:pointer}:host ::ng-deep .launcherContainer:hover ucc-icon{opacity:1}:host ::ng-deep .launcherContainer:hover span,:host ::ng-deep .launcherContainer:hover a{font-family:\"FiraSans SemiBold\"}:host ::ng-deep .launcherTextContent{width:100%;margin-left:8px;color:#373737;font-size:13px}\n"]
            }]
    }], function () { return []; }, { label: [{
            type: Input
        }], hoverLabel: [{
            type: Input
        }], icon: [{
            type: Input
        }], iconClass: [{
            type: Input
        }], _externalHoverLabel: [{
            type: ViewChild,
            args: ['externalHoverlabel']
        }], _externalLabel: [{
            type: ViewChild,
            args: ['externalLabel']
        }], 
    /** @ignore */
    onMouseOver: [{
            type: HostListener,
            args: ['mouseover']
        }], 
    /** @ignore */
    onMouseOut: [{
            type: HostListener,
            args: ['mouseleave']
        }] }); })();

class ButtonLauncherModule {
}
ButtonLauncherModule.ɵfac = function ButtonLauncherModule_Factory(t) { return new (t || ButtonLauncherModule)(); };
ButtonLauncherModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ButtonLauncherModule });
ButtonLauncherModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonLauncherModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    IconModule
                ],
                declarations: [
                    ButtonLauncherComponent
                ],
                exports: [
                    ButtonLauncherComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ButtonLauncherModule, { declarations: function () { return [ButtonLauncherComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        IconModule]; }, exports: function () { return [ButtonLauncherComponent]; } }); })();

/**
 * Este componente se utiliza para la declaración de un Split Button. Este componente de funcionamiento parecido a un botón (con
 * las opciones de estar deshabilitado, en estado de cargando, y su propio método al hacerle click) también tiene la posibilidad
 * de pasarle un array de opciones de tipo [INgwkSplitButtonOptions]{@link INgwkSplitButtonOptions}, que básicamente són el resto
 * de opciones que aparecen al hacer click en el botón de desplegar.
 *
 * @example
 * <ngwk-split-button
 *  [data]="splitButtonOptions"
 *  [buttonText]="'Split Button'"
 *  [isLoading]="isSplitButtonLoading"
 *  [disabled]="splitButtonDisabled"
 *  (buttonClick)="onSplitButtonClick()" >
 * </ngwk-split-button>
 *
 */
class SplitButtonComponent {
    /** @ignore */
    constructor(_renderer) {
        this._renderer = _renderer;
        this._id = null;
        this._data = null;
        this._disabled = false;
        this._buttonText = '';
        this._isAlive = true;
        this._buttonClick = new EventEmitter();
        this._isLoading = false;
        this._popupSettings = { appendTo: 'component', popupClass: POPUP_CLASS_NAME };
        this._contentButtonWidth = null;
        this._splitButton = null;
        this._splitButtonElementRef = null;
        this._splitButtonTextElementRef = null;
    }
    ngAfterViewInit() {
        this._contentButtonWidth = this._splitButtonTextElementRef.nativeElement.clientWidth + 'px';
        this.setArrowId();
        this._splitButton.open.pipe(debounceTime(50), takeWhile(() => this._isAlive))
            .subscribe(() => {
            this.setItemIds();
            this.setMinWidth();
        });
    }
    ngOnDestroy() {
        this._isAlive = false;
    }
    /** @ignore */
    onClick(event) {
        this._buttonClick.emit(event);
    }
    manageDisabledAttribute() {
        if (this._splitButtonTextElementRef) {
            this.disabled ? this._renderer.setAttribute(this._splitButtonElementRef.nativeElement, 'disabled', 'true') : this._renderer.removeAttribute(this._splitButtonElementRef.nativeElement, 'disabled');
        }
    }
    setArrowId() {
        this._splitButtonElementRef.nativeElement.getElementsByClassName('k-button-icon k-button').item(0).setAttribute('id', 'splitButtonArrow');
    }
    setItemIds() {
        this._splitButtonElementRef.nativeElement.querySelectorAll('[role="menuitem"]').forEach((splitButtonItem, index) => {
            splitButtonItem.setAttribute('id', this.data[index].id);
        });
    }
    setMinWidth() {
        const popup = this._splitButtonElementRef.nativeElement.querySelector(`.${POPUP_CLASS_NAME}`);
        const minWidth = this._splitButtonElementRef.nativeElement.offsetWidth > 100 ? this._splitButtonElementRef.nativeElement.offsetWidth : 100;
        popup.style.minWidth = `${minWidth}px`;
    }
    /**
     * Permite obtener el id del Split Button
     */
    get id() {
        return this._id;
    }
    /**
     * Permite definir el id del Split Button
     *
     * @param value El id del Split Button
     */
    set id(value) {
        this._id = value;
    }
    /**
     * Permite obtener el texto del Split Button
     */
    get buttonText() {
        return this._buttonText;
    }
    /**
     * Permite definir el texto del Split Button
     *
     * @param value El texto del Split Button
     */
    set buttonText(value) {
        this._buttonText = value;
    }
    /**
     * Permite obtener las opciones del desplegable del Split Button, que son los botones extras del Split Button. Estas
     * opciones son un array de [INgwkSplitButtonOptions]{@link INgwkSplitButtonOptions}
     */
    get data() {
        return this._data;
    }
    /**
     * Permite definir las opciones del desplegable del Split Button, que son los botones extras del Split Button. Estas
     * opciones son un array de [INgwkSplitButtonOptions]{@link INgwkSplitButtonOptions}
     *
     * @param value Las opciones del desplegable del Split Button
     */
    set data(value) {
        this._data = value;
    }
    /**
     * Permite consultar el estado de disabled del Split Button
     */
    get disabled() {
        return this._disabled;
    }
    /**
     * Permite activar o desactivar el estado de disabled del Split Button
     *
     * @param value Valor que activa o desactiva el estado de disabled del Split Button
     */
    set disabled(value) {
        this._disabled = value;
        this.manageDisabledAttribute();
        if (this._splitButton && this._disabled) {
            this._splitButton.toggle(false);
        }
    }
    /**
     * Permite consultar el estado de loading del Split Button
     */
    get isLoading() {
        return this._isLoading;
    }
    /**
     * Permite activar o desactivar el estado de loading del Split Button
     *
     * @param value Valor que activa o desactiva el estado de loading del Split Button
     */
    set isLoading(value) {
        this._isLoading = value;
    }
    /**
     * Emite un evento cuando se hace click en el botón principal del Split Button
     */
    get buttonClick() {
        return this._buttonClick;
    }
    /** @ignore */
    get popupSettings() {
        return this._popupSettings;
    }
    /** @ignore */
    get contentButtonWidth() {
        return this._contentButtonWidth;
    }
}
SplitButtonComponent.ɵfac = function SplitButtonComponent_Factory(t) { return new (t || SplitButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
SplitButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SplitButtonComponent, selectors: [["ngwk-split-button"]], viewQuery: function SplitButtonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, 7);
        ɵngcc0.ɵɵviewQuery(_c9, 7, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c10, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._splitButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._splitButtonElementRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._splitButtonTextElementRef = _t.first);
    } }, inputs: { id: "id", buttonText: "buttonText", data: "data", disabled: "disabled", isLoading: "isLoading" }, outputs: { buttonClick: "buttonClick" }, decls: 4, vars: 6, consts: [[1, "loadingAnimationButton", 3, "id", "data", "disabled", "popupSettings", "buttonClick"], ["splitButton", ""], [4, "ngIf"], ["class", "alignHorizontalMiddle", 3, "ngStyle", 4, "ngIf"], ["splitButtonText", ""], [1, "alignHorizontalMiddle", 3, "ngStyle"], [1, "loadingSpinner"]], template: function SplitButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "kendo-splitbutton", 0, 1);
        ɵngcc0.ɵɵlistener("buttonClick", function SplitButtonComponent_Template_kendo_splitbutton_buttonClick_0_listener($event) { return ctx.onClick($event); });
        ɵngcc0.ɵɵtemplate(2, SplitButtonComponent_div_2_Template, 3, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(3, SplitButtonComponent_div_3_Template, 2, 3, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("data", ctx.data)("disabled", ctx.disabled)("popupSettings", ctx.popupSettings);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLoading);
    } }, directives: [ɵngcc4.SplitButtonComponent, ɵngcc1.NgIf, ɵngcc1.NgStyle], styles: ["[_nghost-%COMP%]     kendo-splitbutton{margin:4px!important}[_nghost-%COMP%]     kendo-splitbutton.k-button-group .k-button:focus{opacity:.7;box-shadow:none!important}[_nghost-%COMP%]     kendo-splitbutton button.k-button.k-button-icon{height:31px;width:calc(10px + 1.42857143em)}[_nghost-%COMP%]     kendo-splitbutton button[disabled]{background-color:#aaa!important}[_nghost-%COMP%]     kendo-splitbutton button{border:none!important;background:none!important;background-color:#0081c6!important;color:#fff!important;cursor:pointer}[_nghost-%COMP%]     kendo-splitbutton button:first-child{border-left:1px solid white!important;border-top-left-radius:4px;border-bottom-left-radius:4px;padding:0 15px}[_nghost-%COMP%]     kendo-splitbutton button:first-child:hover{opacity:.8}[_nghost-%COMP%]     kendo-splitbutton button:last-child{border-top-right-radius:4px;border-bottom-right-radius:4px}[_nghost-%COMP%]     kendo-splitbutton button:last-child:hover{opacity:.8}"] });
/** @nocollapse */
SplitButtonComponent.ctorParameters = () => [
    { type: Renderer2 }
];
SplitButtonComponent.propDecorators = {
    _splitButton: [{ type: ViewChild, args: ['splitButton', { static: true },] }],
    _splitButtonElementRef: [{ type: ViewChild, args: ['splitButton', { read: ElementRef, static: true },] }],
    _splitButtonTextElementRef: [{ type: ViewChild, args: ['splitButtonText', { read: ElementRef },] }],
    id: [{ type: Input }],
    buttonText: [{ type: Input }],
    data: [{ type: Input }],
    disabled: [{ type: Input }],
    isLoading: [{ type: Input }],
    buttonClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SplitButtonComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-split-button',
                template: "<kendo-splitbutton \r\n    #splitButton\r\n    class=\"loadingAnimationButton\"\r\n    [id]=\"id\"\r\n    [data]=\"data\"\r\n    [disabled]=\"disabled\"\r\n    [popupSettings]=\"popupSettings\"\r\n    (buttonClick)=\"onClick($event)\">\r\n        <div #splitButtonText *ngIf=\"!isLoading\">{{buttonText}}</div>\r\n        <div *ngIf=\"isLoading\" [ngStyle]=\"{ 'width' : contentButtonWidth }\" class=\"alignHorizontalMiddle\">\r\n            <div class=\"loadingSpinner\"></div>\r\n        </div>\r\n</kendo-splitbutton>",
                styles: [":host ::ng-deep kendo-splitbutton{margin:4px!important}:host ::ng-deep kendo-splitbutton.k-button-group .k-button:focus{opacity:.7;box-shadow:none!important}:host ::ng-deep kendo-splitbutton button.k-button.k-button-icon{height:31px;width:calc(10px + 1.42857143em)}:host ::ng-deep kendo-splitbutton button[disabled]{background-color:#aaa!important}:host ::ng-deep kendo-splitbutton button{border:none!important;background:none!important;background-color:#0081c6!important;color:#fff!important;cursor:pointer}:host ::ng-deep kendo-splitbutton button:first-child{border-left:1px solid white!important;border-top-left-radius:4px;border-bottom-left-radius:4px;padding:0 15px}:host ::ng-deep kendo-splitbutton button:first-child:hover{opacity:.8}:host ::ng-deep kendo-splitbutton button:last-child{border-top-right-radius:4px;border-bottom-right-radius:4px}:host ::ng-deep kendo-splitbutton button:last-child:hover{opacity:.8}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { _splitButton: [{
            type: ViewChild,
            args: ['splitButton', { static: true }]
        }], _splitButtonElementRef: [{
            type: ViewChild,
            args: ['splitButton', { read: ElementRef, static: true }]
        }], _splitButtonTextElementRef: [{
            type: ViewChild,
            args: ['splitButtonText', { read: ElementRef }]
        }], id: [{
            type: Input
        }], buttonText: [{
            type: Input
        }], data: [{
            type: Input
        }], disabled: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], buttonClick: [{
            type: Output
        }] }); })();
/** @ignore */
const POPUP_CLASS_NAME = 'splitButtonPopUpMinWidth';

class SplitButtonModule {
}
SplitButtonModule.ɵfac = function SplitButtonModule_Factory(t) { return new (t || SplitButtonModule)(); };
SplitButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SplitButtonModule });
SplitButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            SplitButtonModule$1
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SplitButtonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SplitButtonModule$1
                ],
                declarations: [
                    SplitButtonComponent
                ],
                exports: [
                    SplitButtonComponent
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SplitButtonModule, { declarations: function () { return [SplitButtonComponent]; }, imports: function () { return [CommonModule,
        SplitButtonModule$1]; }, exports: function () { return [SplitButtonComponent]; } }); })();

class ButtonsModule {
}
ButtonsModule.ɵfac = function ButtonsModule_Factory(t) { return new (t || ButtonsModule)(); };
ButtonsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ButtonsModule });
ButtonsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            ButtonsModule$1,
            ToolbarModule,
            ProgressButtonModule,
            ButtonLauncherModule,
            SplitButtonModule
        ], ToolbarModule, ProgressButtonModule, ButtonLauncherModule, SplitButtonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ButtonsModule$1,
                    ToolbarModule,
                    ProgressButtonModule,
                    ButtonLauncherModule,
                    SplitButtonModule
                ],
                exports: [
                    ToolbarModule,
                    ProgressButtonModule,
                    ButtonLauncherModule,
                    SplitButtonModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ButtonsModule, { imports: function () { return [ButtonsModule$1, ToolbarModule, ProgressButtonModule, ButtonLauncherModule, SplitButtonModule]; }, exports: function () { return [ToolbarModule, ProgressButtonModule, ButtonLauncherModule, SplitButtonModule]; } }); })();

var NgwkButtonStyle;
(function (NgwkButtonStyle) {
    /** Estilo primario del botón. Se utiliza para remarcar qué botón és el importante */
    NgwkButtonStyle["Primary"] = "buttonPrimary";
    /** Estilo secundario del botón. Se utiliza para mostrar menos importancia que el botón con estilo primario */
    NgwkButtonStyle["Secondary"] = "buttonPrimaryTransparent";
})(NgwkButtonStyle || (NgwkButtonStyle = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonLauncherComponent, ButtonLauncherModule, ButtonsModule, NgwkButtonStyle, ProgressButtonDirective, ProgressButtonModule, SplitButtonComponent, SplitButtonModule, ToolbarComponent, ToolbarItemComponent, ToolbarModule };

